import { db } from './firebase.js';
import { collection, addDoc, getDocs, query, orderBy, where, doc, updateDoc } from 'firebase/firestore';

export const FinancialService = {
    // Agregar movimiento financiero (Ingreso o Gasto)
    async addTransaction(caseId, data) {
        try {
            const financeRef = collection(db, "cases", caseId, "finance");
            const docRef = await addDoc(financeRef, {
                ...data,
                amount: parseFloat(data.amount),
                timestamp: new Date(),
                isPaid: data.isPaid || false,
                metadata: {
                    currency: 'USD',
                    paymentMethod: 'pending'
                },
                auditTrail: [{
                    action: 'initial_creation',
                    timestamp: new Date(),
                    user: data.author || 'system'
                }]
            });
            return docRef.id;
        } catch (e) {
            console.error("Error agregando transacción:", e);
            throw e;
        }
    },

    // Obtener movimientos de un caso
    async getTransactions(caseId) {
        try {
            const financeRef = collection(db, "cases", caseId, "finance");
            const q = query(financeRef, orderBy("timestamp", "desc"));
            const querySnapshot = await getDocs(q);
            return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        } catch (e) {
            console.error("Error obteniendo transacciones:", e);
            throw e;
        }
    },

    // Calcular resumen financiero del caso
    async getFinancialSummary(caseId) {
        const trans = await this.getTransactions(caseId);
        const summary = {
            totalIncome: 0,
            totalExpenses: 0,
            pendingFees: 0,
            balance: 0
        };

        trans.forEach(t => {
            if (t.type === 'income') {
                summary.totalIncome += t.amount;
            } else {
                summary.totalExpenses += t.amount;
            }
            if (!t.isPaid && t.category === 'honorarios') {
                summary.pendingFees += t.amount;
            }
        });

        summary.balance = summary.totalIncome - summary.totalExpenses;
        return summary;
    }
};
